export default __webpack_public_path__ + "locales/zh-CN/Notifications.json?hash=8a496fe8b89c821c59fe2fe2e04f1cb2";